import $ from 'jquery';
import 'slick-carousel/slick/slick';

$(function () {
    // Hamberger menu
    $(".hamberger").on("click",function (e) {
        e.preventDefault();
        $(".nav-bar").fadeIn();
        var left = $(".contact").offset().left;
        $(".contact").css({
            "position": "fixed",
            "left":left,
            "margin-left":0
        });

        setTimeout(function(){
            var left_close = $(".hamberger").offset().left;
            $(".close-button").css({
                "position": "fixed",
                "left":left_close,
            });
        },200);

        $("body").css({
            "position": "fixed",
            "overflow-y": "scroll",
        });

    })
    $(window).on("load resize",function () {
        setTimeout(function(){
            var left_close = $(".hamberger").offset().left;
            $(".close-button").css({
                "position": "fixed",
                "left":left_close,
            });
        },200);
    })
    $(".close-button").on("click",function (e) {
        e.preventDefault();
        $(".nav-bar").fadeOut();
        $(".contact").attr("style","");
        $("body").attr("style","");
    })

    // Dropdown menu header
    if ($(window).width() < 768) {
        $(".inner-nav ul .nav-item").on("click",function (e) {
            if($(e.target).is(".nav-item")) {
                e.preventDefault();
                if ($(this).hasClass("close")) {
                    $(this).find(".menu-childen").slideDown();
                    $(this).addClass("open").removeClass("close");
                } else {
                    $(this).find(".menu-childen").slideUp();
                    $(this).addClass("close").removeClass("open");
                }
            }
        });

        // Dropdown menu footer
        $(".menu-item").on("click",function (e) {
            if(!$(e.target).is("a") && $(this).find(".nav-childen").length > 0){
                e.preventDefault();
                if($(this).hasClass("close")){
                    $(this).find(".nav-childen").slideDown();
                    $(this).addClass("open").removeClass("close");
                }else{
                    $(this).find(".nav-childen").slideUp();
                    $(this).addClass("close").removeClass("open");
                }
            }
        });
    }

    $(".page-menu ul li a").on("click",function (e) {
        e.preventDefault();
        var target = $(this).attr("href");
        $('html, body').animate({scrollTop : $(target).offset().top - 80},800);
    })
})

// Back to top
$(window).scroll(function(){
    // Show button after 100px
    var showAfter = 100;
    if ($(this).scrollTop() > showAfter ) {
        $('.back-to-top').fadeIn();
    } else {
        $('.back-to-top').fadeOut();
    }
});

//Click event to scroll to top
$('.back-to-top').click(function(){
    $('html, body').animate({scrollTop : 0},800);
    return false;
});

$(function () {
    $('.collapse-container').each(function(){
        var _thisBlock = $(this),
            collapseBtn = _thisBlock.find('.collapse-btn');

        $(collapseBtn).on('click',  function(e) {
            let collapse = $(this).closest('.collapse');
            console.log(collapse)
            if (collapse.hasClass('active')) {
                collapse.toggleClass('active')
                collapse.children('.collapse-contents')
                    .slideUp('fast')
            } else {
                collapse.toggleClass('active')
                collapse.children('.collapse-contents').slideDown('fast')
            }
        })

    })

    $("#confirm").on("click",function (e){
        e.preventDefault();
        var validate = 0;
        $("form").find(".error").remove();
        $('input[type="text"],input[type="tel"],input[type="email"]').each(function (){
            if($(this).val() == ""){
                validate = 1;
                var errormess = '<div class="error">Please fill out this field</div>';
                $(this).closest(".input").append(errormess);
            }
        });
        if($('input[type="email"]').val() !== ""){
            if(!validateEmail($('input[type="email"]').val())){
                validate = 1;
                var errormess = '<div class="error">Please enter the correct format.</div>';
                $('input[type="email"]').closest(".input").append(errormess);
            }
        }
        if($('select').val() == 0){
            validate = 1;
            var errormess = '<div class="error">Please select one.</div>';
            $('select').closest(".input").append(errormess);
        }
        if(!$('#privacy').is(":checked")){
            validate = 1;
            var errormess = '<div class="error">Please confirm and agree to the privacy policy before sending.</div>';
            $('#privacy').closest(".input").append(errormess);
        }
        if(validate == 1){
            var target = $(".error").eq(0).offset().top - 80;
            $('html, body').animate({scrollTop : target },800);
        }
        if(validate == 0){
            window.location.replace("/en/contact/form_confirm/");
        }
    })

    $("input, textarea, select").on("focus change",function (){
        $(this).closest(".input").find(".error").remove();
    });
});
function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}